module.exports = __webpack_public_path__ + "img/html5.377d56c2.svg";